import {ref} from 'vue';
export class EditorWindowsLibrariesManagerControllerClass {
	private static _instance: EditorWindowsLibrariesManagerControllerClass;
	static instance() {
		return (this._instance = this._instance || new EditorWindowsLibrariesManagerControllerClass());
	}

	private constructor() {}

	private _displayed = ref(false);

	displayed(): boolean {
		return this._displayed.value;
	}

	// mutations
	open(): void {
		this._displayed.value = true;
	}
	close() {
		this._displayed.value = false;
	}
}

export const EditorWindowsLibrariesManagerController = EditorWindowsLibrariesManagerControllerClass.instance();
